import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const dropdownItemStyling = cva('hover:bg-bg-subtle/50 px-stack py-stack-tight cursor-pointer focus:outline-none flex items-center gap-stack-tight', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'text-fg-muted',
            [ElementIntent.Danger]: 'text-danger',
        },
        disabled: {
            true: 'cursor-not-allowed opacity-80 hover:bg-transparent',
            false: 'cursor-pointer',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
        disabled: false,
    },
});
